import { withAuthenticationRequired } from '@auth0/auth0-react';
import { useParams } from 'react-router-dom';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import CalendarLayoutModelDetail from '@app/pages/settings/CalendarLayoutModelDetail.tsx';
import Intro from '@app/layout/Intro.tsx';
import React from 'react';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';
import { PermissionTypesEnum } from '@api/ringil-api.v2.tsx';

const CalendarLayoutModelPage = () => {
  const { tr } = useTranslationLgs();
  const { modelId } = useParams();

  return (
    <ResponsiveLayout
      title={tr(`CalendarLayout.pageTitle`, `Calendar card layouts`)}
      oneOfPermission={[PermissionTypesEnum.PERMISSION_CALENDAR_LAYOUT_READ, PermissionTypesEnum.PERMISSION_CALENDAR_LAYOUT_RW]}
    >
      <CalendarLayoutModelDetail modelId={modelId} />
    </ResponsiveLayout>
  );
};

export default withAuthenticationRequired(CalendarLayoutModelPage, {
  onRedirecting: () => <Intro />,
});
